<template>
  <aside class="column column-small hidden lg:block">
    <ShortProfileBox />
  </aside>
</template>

<script>
import ShortProfileBox from "@/components/Layout/ShortProfileBox";

export default {
  name: "Sidebar",
  components: { ShortProfileBox },
  data() {
    return {
      open: false,
    };
  },
};
</script>

<style scoped>
aside {
  @apply bg-white fixed bottom-0 w-full left-0  z-30 px-4;
  transition: 0.5s;

  @screen lg {
    @apply bg-white left-auto top-auto px-0;
    position: initial;
  }


}

.column-small {
  max-height: 380px;
}
</style>
